import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted, useTemplateRef} from 'vue'
  import OnePageNavigation from '../onePageNavigation/onePageNavigation.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'contentIndexHeader',
  props: {
    sectionIdPrefix: { default: 'content-index__' }
  },
  setup(__props: any) {

  const props = __props;

  const rootEl = useTemplateRef<OnePageNavigation>('rootEl');
  const navigationData = ref<{key: string, id: string}[]>([]);

  onMounted(() => {
    const teaserNode = rootEl.value.$el.closest('.content-index');
    const entryNodes = Array.prototype.slice.call(teaserNode.querySelectorAll('.content-index__head'));

    entryNodes.forEach((entry: HTMLElement) => {
      const text = entry.innerText.replace(/\r?\n|\r|\s/g, '');
      const id = props.sectionIdPrefix + text;
      const hasContent = document.getElementById(id).childNodes.length;
      navigationData.value.push({
        key: text,
        id: hasContent ? id : ''
      });
    });
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnePageNavigation, {
    class: "content-index-header",
    "offset-basis": -70,
    "hide-on-mobile": false,
    "modify-url": false,
    ref_key: "rootEl",
    ref: rootEl
  }, null, 512 /* NEED_PATCH */))
}
}

})